// pillowai-chat.js
// Single Loading on button, no extra status block, no disclaimer note.

document.addEventListener('DOMContentLoaded', function () {
  const chatInput  = document.getElementById('pillowai-input');
  const sendButton = document.getElementById('pillowai-send');
  const resultsDiv = document.getElementById('pillowai-results');

  // Progress elements (no status header, only bar + message)
  const progressRoot  = document.getElementById('pillowai-progress');
  const progressFill  = document.getElementById('pillowai-progress-fill');
  const progressMsg   = document.getElementById('pillowai-progress-message');
  const progressBarEl = document.querySelector('.pillowai-progress-bar');

  // Auto-resize textarea
  if (chatInput) {
    chatInput.addEventListener('input', function () {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
  }

  if (chatInput && sendButton && resultsDiv) {
    sendButton.addEventListener('click', sendQuery);
  }

  // Heuristic progress animation
  let progressTimer = null;
  let progressValue = 0;
  let stepIndex = 0;

  const stepMessages = [
    'Starting analysis...',
    'Extracting style and color palette...',
    'Matching patterns and textures...',
    'Scoring compatibility...',
    'Searching store inventory...',
    'Curating top matches...'
  ];

  async function sendQuery() {
    const query = chatInput.value.trim();
    if (!query) return;

    // Start loading state (only the button says "Loading...")
    resultsDiv.innerHTML = '';
    sendButton.disabled = true;
    chatInput.disabled = true;
    sendButton.textContent = 'Loading...';

    startProgress();

    try {
      const response = await fetch('https://42vnn6vwt9.execute-api.eu-central-1.amazonaws.com/prod/suggest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: query })
      });

      if (!response.ok) {
        let message = 'API request failed with status ' + response.status;
        try {
          const err = await response.json();
          if (err && err.message) message = err.message;
        } catch (_) {}
        throw new Error(message);
      }

      const data = await response.json();
      finishProgress(true);
      resultsDiv.innerHTML = formatResults(data);
    } catch (error) {
      finishProgress(false);
      const safe = error && error.message ? escapeHtml(error.message) : 'Unknown error';
      resultsDiv.innerHTML = `<p style="text-align: center; color: red;">An error occurred. Please try again later. (Details: ${safe})</p>`;
    } finally {
      sendButton.disabled = false;
      chatInput.disabled = false;
      sendButton.textContent = 'Send for Suggestion';
    }
  }

  function formatResults(data) {
    if (data.error) {
      return `<p style="text-align: center; color: red;">${escapeHtml(data.error)}</p>`;
    }
    if (!data.aestheticAnalysis || !Array.isArray(data.product_recommendations)) {
      return '<p style="text-align: center; color: red;">Received incomplete data from the server. Please try again.</p>';
    }

    let html = `
      <h3 style="font-size: 1.4em; text-align: left; font-weight: 600; margin-bottom: 10px;">Design Analysis</h3>
      <p style="text-align: left; margin-bottom: 30px; color: #555; font-size: 1.05em;">
        ${escapeHtml(data.aestheticAnalysis)}
      </p>
      <div class="pillowai-results-grid">
    `;

    data.product_recommendations.forEach(product => {
      const imageUrl   = product.productImageURL1 || 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
      const productURL = product.productURL || '#';
      const title      = product.productTitle || 'Product Title Unavailable';
      const desc       = product.productDescription || '';
      const why        = product.modelGeneratedCompatibilityText || 'N/A';

      html += `
        <div class="pillowai-product-card">
          <a href="${escapeAttr(productURL)}" target="_blank" style="text-decoration: none;">
            <img src="${escapeAttr(imageUrl)}" alt="${escapeAttr(title)}">
          </a>
          <h4><a href="${escapeAttr(productURL)}" target="_blank">${escapeHtml(title)}</a></h4>
          <p>${escapeHtml(desc)}</p>
          <p><strong>Why this pillow:</strong> ${escapeHtml(why)}</p>
        </div>
      `;
    });

    html += '</div>';
    return html;
  }

  /* ===== Progress control (no second status block) ===== */
  function startProgress() {
    if (!progressRoot) return;
    progressValue = 0;
    stepIndex = 0;

    progressRoot.style.display = 'block';
    progressRoot.setAttribute('aria-hidden', 'false');
    progressMsg.textContent = stepMessages[0];
    updateProgressUI(0);

    // Move to ~88% while waiting for the response
    progressTimer = setInterval(() => {
      const delta = Math.random() * 7 + 3;   // 3–10
      progressValue = Math.min(progressValue + delta, 88);
      updateProgressUI(progressValue);

      const threshold = 88 / (stepMessages.length - 1);
      if (progressValue >= (stepIndex + 1) * threshold && stepIndex < stepMessages.length - 1) {
        stepIndex++;
        progressMsg.textContent = stepMessages[stepIndex];
      }
    }, 600);
  }

  function finishProgress(success = true) {
    if (!progressRoot) return;
    if (progressTimer) { clearInterval(progressTimer); progressTimer = null; }

    progressMsg.textContent = success ? 'Preparing results...' : 'An error occurred.';
    updateProgressUI(100);

    setTimeout(() => {
      progressRoot.style.display = 'none';
      progressRoot.setAttribute('aria-hidden', 'true');
      progressMsg.textContent = stepMessages[0];
      updateProgressUI(0);
    }, 700);
  }

  function updateProgressUI(val) {
    const pct = Math.max(0, Math.min(100, Math.round(val)));
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressBarEl) progressBarEl.setAttribute('aria-valuenow', String(pct));
  }

  /* ===== Escape helpers ===== */
  function escapeHtml(str){
    return String(str)
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }
  function escapeAttr(str){ return escapeHtml(str); }
});
